<div class="gu-page">

  <div class="gu-page-header">
    <div class="gu-page-subtitle">{{ 'USUARIOS.SUBTITLE' | translate }}</div>
    <button type="button" class="em-btn em-btn--primary" (click)="abrirCrear()">
      <mat-icon>person_add</mat-icon> {{ 'USUARIOS.NEW' | translate }}
    </button>
  </div>

  <div class="gu-stats">
    <div class="gu-stat">
      <div class="gu-stat__value">{{ stats.total }}</div>
      <div class="gu-stat__label">{{ 'USUARIOS.STAT_TOTAL' | translate }}</div>
    </div>
    <div class="gu-stat">
      <div class="gu-stat__value gu-stat__value--success">{{ stats.activos }}</div>
      <div class="gu-stat__label">{{ 'USUARIOS.STAT_ACTIVE' | translate }}</div>
    </div>
    <div class="gu-stat">
      <div class="gu-stat__value gu-stat__value--muted">{{ stats.inactivos }}</div>
      <div class="gu-stat__label">{{ 'USUARIOS.STAT_INACTIVE' | translate }}</div>
    </div>
    <div class="gu-stat">
      <div class="gu-stat__value">{{ stats.rolesConfigurados }}</div>
      <div class="gu-stat__label">{{ 'USUARIOS.STAT_ROLES' | translate }}</div>
    </div>
  </div>

  <div class="gu-toolbar">
    <input
      type="text"
      class="em-input"
      [formControl]="filtroBusqueda"
      [placeholder]="'USUARIOS.SEARCH_PH' | translate"
    />
    <select class="em-select" [formControl]="filtroEstado">
      <option value="todos">{{ 'USUARIOS.ALL_STATES' | translate }}</option>
      <option value="activos">{{ 'USUARIOS.ACTIVE_PL' | translate }}</option>
      <option value="inactivos">{{ 'USUARIOS.INACTIVE_PL' | translate }}</option>
    </select>
    <select class="em-select" [formControl]="filtroRol">
      <option [ngValue]="'todos'">{{ 'USUARIOS.ALL_ROLES' | translate }}</option>
      <option *ngFor="let r of rolesDisponibles" [ngValue]="r.id">{{ r.nombre }}</option>
    </select>
  </div>

  <div class="gu-table-wrapper listado listado--cards-accent">
    <table mat-table [dataSource]="usuarios" class="mat-elevation-z0">

      <ng-container matColumnDef="usuario">
        <th mat-header-cell *matHeaderCellDef>{{ 'USUARIOS.COL_USER' | translate }}</th>
        <td mat-cell *matCellDef="let u" [attr.data-label]="'USUARIOS.COL_USER' | translate" data-role="title">
          <div class="gu-user-cell">
            <span class="gu-avatar">{{ iniciales(u) }}</span>
            <span class="gu-user-name">{{ u.nombre }} {{ u.apellido1 }} {{ u.apellido2 }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="documento">
        <th mat-header-cell *matHeaderCellDef class="col-hide-sm">{{ 'USUARIOS.COL_DOC' | translate }}</th>
        <td mat-cell *matCellDef="let u" [attr.data-label]="'USUARIOS.COL_DOC' | translate" class="col-hide-sm">
          <span class="gu-mono">{{ u.numero_documento }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{ 'USUARIOS.COL_EMAIL' | translate }}</th>
        <td mat-cell *matCellDef="let u" [attr.data-label]="'USUARIOS.COL_EMAIL' | translate" data-role="meta">
          <span class="gu-muted">{{ u.email }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef class="col-hide-xs">{{ 'USUARIOS.COL_ROLES' | translate }}</th>
        <td mat-cell *matCellDef="let u" [attr.data-label]="'USUARIOS.COL_ROLES' | translate" class="col-hide-xs">
          <div class="gu-role-chips">
            <span *ngFor="let r of rolesPreview(u)" class="gu-badge gu-badge--role">{{ r.nombre }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>{{ 'USUARIOS.COL_STATUS' | translate }}</th>
        <td mat-cell *matCellDef="let u" [attr.data-label]="'USUARIOS.COL_STATUS' | translate" data-role="status">
          <span class="gu-badge" [class.gu-badge--active]="u.activo" [class.gu-badge--inactive]="!u.activo">
            {{ u.activo ? ('COMMON.ACTIVE' | translate) : ('COMMON.INACTIVE' | translate) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="alta">
        <th mat-header-cell *matHeaderCellDef class="col-hide-sm">{{ 'USUARIOS.COL_CREATED' | translate }}</th>
        <td mat-cell *matCellDef="let u" [attr.data-label]="'USUARIOS.COL_CREATED' | translate" class="col-hide-sm">
          <span class="gu-muted gu-small">{{ formatFecha(u.fechaAlta) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef class="em-th-actions">{{ 'COMMON.ACTIONS' | translate }}</th>
        <td mat-cell *matCellDef="let u" data-role="actions" class="em-td-actions">
          <div class="em-actions-wrap">
            <button type="button" class="em-icon-btn"
                    [matTooltip]="'USUARIOS.TOOLTIP_EDIT' | translate"
                    matTooltipClass="em-tooltip"
                    matTooltipPosition="left"
                    (click)="abrirEditar(u)">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" class="em-icon-btn"
                    [matTooltip]="'USUARIOS.TOOLTIP_ROLES' | translate"
                    matTooltipClass="em-tooltip"
                    matTooltipPosition="left"
                    (click)="abrirRoles(u)">
              <mat-icon>shield</mat-icon>
            </button>
            <button *ngIf="!u.email_confirmado"
                    class="em-icon-btn em-icon-btn--warn"
                    [matTooltip]="'USUARIOS.TOOLTIP_CONFIRM' | translate"
                    matTooltipClass="em-tooltip"
                    matTooltipPosition="left"
                    (click)="forzarConfirmacion(u)">
              <mat-icon>mark_email_unread</mat-icon>
            </button>
            <button type="button" class="em-icon-btn"
                    [matTooltip]="u.activo ? ('USUARIOS.TOOLTIP_DEACTIVATE' | translate) : ('USUARIOS.TOOLTIP_REACTIVATE' | translate)"
                    matTooltipClass="em-tooltip"
                    matTooltipPosition="left"
                    (click)="toggleActivo(u)">
              <mat-icon>{{ u.activo ? 'toggle_on' : 'toggle_off' }}</mat-icon>
            </button>
            <button type="button" class="em-icon-btn em-icon-btn--danger"
                    [matTooltip]="'USUARIOS.TOOLTIP_DELETE' | translate"
                    matTooltipClass="em-tooltip"
                    matTooltipPosition="left"
                    (click)="confirmarEliminar(u)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.gu-row--inactive]="!row.activo"></tr>
    </table>

    <div class="gu-empty" *ngIf="!loading && usuarios.length === 0">
      {{ 'USUARIOS.EMPTY' | translate }}
    </div>
  </div>

  <mat-paginator
    [length]="totalElements"
    [pageSize]="size"
    [pageIndex]="page"
    [pageSizeOptions]="[5, 10, 25, 100]"
    (page)="onPageChange($event)"
    showFirstLastButtons>
  </mat-paginator>
</div>
